import { Flex, Spin } from "antd";

const Spinner = () => {
  return (
    <Flex style={{ height: "60vh" }} align="center" justify="center" gap="">
      <Spin size="large" />
    </Flex>
  );
};

export default Spinner;
